var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"number-box",attrs:{"title":_vm.tooltip}},[_c('div',{staticClass:"number-label"},[_vm._v("\n        "+_vm._s(_vm.number)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('div',{staticClass:"icon",class:_vm.icon + '-icon-bg'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }